export const onClientEntry = () => {
  if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const shouldUpdateScroll = ({ prevRouterProps, routerProps }: any) => {
  if (
    prevRouterProps &&
    prevRouterProps.location.pathname !== routerProps.location.pathname
  ) {
    // Force scroll to top on real route change
    window.scrollTo(0, 0);
    return false; // prevent Gatsby from restoring previous scroll
  }
  return true;
};
